export const JWPLAYER_SITE_ID = 'Z9cAIGUU'
export const JWPLAYER_DEFAULT_PLAYER_ID = 'JBa1XMZp'

export const JWPLAYER_PLAYERS: { id: string; name: string }[] = [
  { id: 'JBa1XMZp', name: 'Tennis.com Article/News' },
  { id: 'Cfj5Z5Dn', name: 'Tennis.com Homepage 2 & 3' },
  { id: '4hRrHCOA', name: 'Tennis.com Homepage 1' },
  { id: 'yyrjrCRS', name: 'Z Internal Player' },
  { id: '3R7PqOD3', name: 'Tennis.com Article/News NO AUTO PLAY' },
  { id: 'ebjX2BvY', name: 'Tennis.com Scores' },
  { id: '5DQSGiTe', name: 'No PreRoll/No Auto Play' },
  { id: 'PAYpMj28', name: 'Tennis.com Videos Page' },
  { id: 'Pnmr9apC', name: 'Sponsor ZipRecruiter' },
  { id: 'KiAlmc8F', name: 'WTA Original 9' },
]
